import { http } from "./http";
import type { paths } from "./schema";
import type { JsonResponse } from "./types";

type ServiceGet = paths["/service"]["get"];
export type ServiceList = JsonResponse<ServiceGet, 200>;

export async function getServices(): Promise<ServiceList> {
  const { data } = await http.get<unknown>("/service");
  return Array.isArray(data) ? (data as ServiceList) : [];
}

type ServiceGetOne = paths["/service/{id}"]["get"];
export type ServiceOne = JsonResponse<ServiceGetOne, 200>;

export async function getService(id: number): Promise<ServiceOne | null> {
  const { data } = await http.get<unknown>(`/service/${id}`);

  if (data && typeof data === "object" && !Array.isArray(data)) {
    return data as ServiceOne;
  }

  return null;
}
